import React from 'react'
import './team.scss'
// import {Modal} from 'antd'

import AppFooter from './footer/footer';
import NavBarTest from "./navbar/NavBarTest";
import {Col, Container, Row, CardDeck} from "react-bootstrap";
import TeamCard from "./team/TeamCard"
// import TeamLearnMore from "./team/TeamLearnMore";
import TeamModal from "./team/TeamModal";

const Team = () => {

        return (
            <React.Fragment>
                <NavBarTest/>
                <Container className="team-container">

                    <Row className="jumbotron jumbotron-fluid">
                        <Col xs={12} md={12} className="text-center">
                            <h1 className="display-4">Meet the Team</h1>
                            <h4>We want to thank all our contributors in bringing this idea
                                possible:</h4>
                        </Col>
                    </Row>
                    <div className="box">
                        <Row>
                            <CardDeck>
                                <TeamCard teamName="Brima Manso Bangura"
                                          teamBio="Brima Manso Bangura is a visionary, problem solver, and founder of
                                           Zimble. At age 15, he built a generator from scrap materials that he used
                                           to bring clean electricity in his slum community in Sierra Leone. He
                                           received a scholarship to study Leadership and Entrepreneurship is one of
                                           the most prestigious pre-university institutions in Africa: The African
                                           Leadership Academy in Johannesburg, South Africa. A few months after his
                                           graduation from ALA, he became the youngest Sierra Leonean to receive an
                                           award from Queen Elizabeth the II at Buckingham Palace, United Kingdom."
                                          teamImage={require('../images/Brimamanso.jpg')}
                                          teamLearnMore=
                                              {<TeamModal name="Brima Manso Bangura">
                                                  <p>He is currently studying Business and Entrepreneurship at the
                                                      Watson
                                                      Institute at
                                                      Lynn University. The Watson Institute
                                                      according to Brima is the Olympic training ground for social
                                                      entrepreneurs of the
                                                      21stcentury. Brima founded a venture
                                                      Revalite, focused on helping students around the world
                                                      with access to a clean, affordable, and reliable source of light
                                                      so
                                                      that they can
                                                      study conveniently at night without
                                                      inhaling the smoke from candles and kerosene lamps.</p>

                                                  <p>More than ever, Brima’s vision for Zimble is to create innovative
                                                      technologies that
                                                      would help students around the world
                                                      get access to educational technologies, reach their potential, and
                                                      become better
                                                      versions of themselves. The Zimble platform is just
                                                      one-way Brima is achieving this vision.

                                                  </p>
                                              </TeamModal>}
                                />

                                <TeamCard teamName="Melanie Roger"
                                          teamBio="Melanie Roger is a certified Project Management Professional and six
                                           sigma blackbelt with over 20 years of field experience. She is an expert in
                                            business operations, business optimization, business startups, mergers and
                                            acquisitions, integration management, advanced data analytics, and digital
                                            transformation. She is the Chief Operational Officer of Zeus Consulting
                                            Services a certified woman-owned and minority-owned business."
                                          teamImage={require('../images/mel.jpg')}
                                          teamLearnMore=
                                              {<TeamModal name="Melanie Roger">
                                                  <p>She has helped numerous business owners
                                                      achieve their dream of business startups and has a proven track
                                                      record of optimizing
                                                      small businesses and large
                                                      corporations achieve lower operating and maintenance costs while
                                                      increasing revenue
                                                      and sales. Melanie has a passion for
                                                      the next generation and has volunteered countless hours ensuring
                                                      underprivileged
                                                      youth have access to quality education
                                                      and creating programs so that they have hands-on access to STEM
                                                      programs. </p><p>She
                                                  also believes in providing people with
                                                  second chances and volunteers with homeless outreach programs that aim
                                                  to rehabilitate
                                                  and reintroduce those who have
                                                  been forgotten back into society.</p>
                                              </TeamModal>}
                                />

                                <TeamCard teamName="Xiara Del Valle"
                                          teamBio="Xiara Del Valle is currently a student of Lynn University, completing
                                           studies in both Political Science and Fashion and Retail with a minor in
                                           Social Entrepreneurship. Her education has also lead her to completing a
                                           semester at Harvard University Extension school, where she was able to
                                           further her interests in women security and mass genocides."
                                          teamImage={require('../images/xia.jpg')}
                                          teamLearnMore=
                                              {<TeamModal name="Xiara Del Valle">
                                                  <p> Her work and passions without question reside in empowering
                                                      others, with specific
                                                      concentration in women and youth empowerment. Through this, Del
                                                      Valle has been able
                                                      to work with women cooperatives in Kayonza, Rwanda as well as
                                                      start her own
                                                      nonprofit, It’s H.E.R. Business (Helping Everyone Rebuild).</p>
                                                  <p> Her organization focuses on bringing the gaps between design and
                                                      social issues.
                                                      Through ethical fashion, women and youth around the world have
                                                      been able to find a
                                                      voice in injustices of poverty, a lack of education, sexual abuse
                                                      and sexual
                                                      assault.</p>
                                              </TeamModal>}
                                />
                            </CardDeck>
                        </Row>


                    <Row>
                        <CardDeck>
                            <TeamCard teamName="Scott Leblanc"
                                        teamBio="Scott LeBlanc is a creative design professional with over 20 years
                                        of experience in art direction, design, and illustration. LeBlanc’s work has
                                        received national recognition with Gold and Silver Addy awards from the
                                        American Advertising Federation. He possesses a unique combination of
                                        advertising and marketing experience that can be effectively used to drive
                                        client objectives. He believes strongly in staying on the leading edge of
                                        technology."
                                        teamImage={require('../images/Scott LeBlanc.jpg')}
                            />

                            <TeamCard teamName="Gibson Munene"
                                        teamBio=" Gibson Munene is a software developer with a special interest in
                                        business, entrepreneurship, networking, blockchain, and machine learning.
                                        He has in the past been involved in the creation of peer to peer apps,
                                        blockchain solutions, DAAps, and machine learning algorithms."
                                        teamImage={require('../images/gibson.jpg')}
                            />

                            <TeamCard teamName="Aliesana Sandoval"
                                        teamBio="Aliesana is a social entrepreneur who’s passion is to serve
                                others by creating content that empowers, encourages, and
                                educates others to heal, live, and thrive in their day-to-day lives."
                                        teamImage={require('../images/Alie.png')}

                            />
                        </CardDeck>
                    </Row>

                    <Row>
                        <CardDeck>
                            <TeamCard teamName="Kervin Noel"
                                        teamBio="Kervin Noel was born in Haiti in 1999 and eventually moved to Florida
                                        in 2005. Ever since he can remember, he has had a passion for art. That
                                        passion later developed into a proficiency for Graphic Design. Today he is in
                                        his third year of University, studying to receive his Bachelor of Fine Arts
                                        in Graphic Design. He has many plans for the future, including launching a
                                        clothing brand later this year."
                                        teamImage={require('../images/Noel.jpg')}
                            />

                            <TeamCard teamName="Jaelin Forestier"
                                        teamBio="Jaelin Forestier is a senior at Lynn university studying graphic
                                        designand loves to illustrate as well as animate."
                                        teamImage={require('../images/Jaelin.jpeg')}
                            />

                            <TeamCard teamName="Salma Moran"
                                        teamBio="Salma Moran is a B.F.A. Film Production student at Lynn University.
                                        She has a knack for leadership, organization, and creating art that emits a
                                        strong message in many forms. Directing and editing aren’t her only passions:
                                        she also has a minor on Social Impact because she believes that actions speak
                                        louder than words. Sal wants to create content in the future that portrays the
                                        imperfections in this world and brings to light conversations towards making
                                        the world a better place."
                                        teamImage={require('../images/Sal.jpg')}

                            />
                        </CardDeck>
                    </Row>


                        <Row>
                            <CardDeck>
                                <TeamCard teamName="Rellika Kisyula"
                                          teamBio="Rellika Kisyula is a Full Stack Developer. He is a graduate from Michigan
                                           State University where he specialized in Human Computer Interaction. He is passionate
                                            about ICT4D, human-centered software design and computational mathematics"
                                          teamImage={require('../images/rellika.jpeg')}
                                />

                                <TeamCard teamName="Joseph Mpo Yeti"
                                          teamBio="Joseph is a graduate of the African Leadership Academy currently pursuing a
                                          Bachelor of Arts in Information Science at Michigan State University. He is passionate about
                                          Software Engineering and Entrepreneurship and would like to use its power to improve the quality
                                          and availability of educational resources."
                                          teamImage={require('../images/joseph.jpg')}
                                />

                                <TeamCard teamName="Monique Mahabir"
                                          teamBio="Monique Mahabir recently graduated with her B.S. in Psychology at
                                          Lynn University. She hopes to expand her knowledge and expertise in
                                          psychology, using it to support organizations and grassroots groups better
                                          communities and advocate for social change. She is interested in the field of
                                          Community Psychology."
                                          teamImage={require('../images/Monique.jpeg')}

                                />
                            </CardDeck>
                        </Row>

                    </div>
                </Container>

            {/*<section class="team">*/}
            {/*    <div class="container">*/}
            {/*        <h4>We want to thank all our contributors in bringing this idea possible:</h4>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}

            {/*                <img src={require('../images/Brimamanso.jpg')} alt="team img"/>*/}
            {/*                <h4>Brima Manso Bangura</h4>*/}
            {/*                <p>*/}
            {/*                    Brima Manso Bangura is a visionary, problem solver, and founder of Zimble. At age*/}
            {/*                    15, he built a generator from scrap materials that he used to bring clean*/}
            {/*                    electricity in his slum community in Sierra Leone. He received a scholarship to*/}
            {/*                    study Leadership and Entrepreneurship is one of the most prestigious pre-university*/}
            {/*                    institutions in Africa: The African Leadership Academy in Johannesburg, South*/}
            {/*                    Africa. A few months after his graduation from ALA, he became the youngest Sierra*/}
            {/*                    Leonean to receive an award from Queen Elizabeth the II at Buckingham Palace, United*/}
            {/*                    Kingdom.</p>*/}

            {/*                <p>He is currently studying Business and Entrepreneurship at the Watson Institute at*/}
            {/*                    Lynn University. The Watson Institute*/}
            {/*                    according to Brima is the Olympic training ground for social entrepreneurs of the*/}
            {/*                    21stcentury. Brima founded a venture*/}
            {/*                    Revalite, focused on helping students around the world*/}
            {/*                    with access to a clean, affordable, and reliable source of light so that they can*/}
            {/*                    study conveniently at night without*/}
            {/*                    inhaling the smoke from candles and kerosene lamps.</p>*/}

            {/*                <p>More than ever, Brima’s vision for Zimble is to create innovative technologies that*/}
            {/*                    would help students around the world*/}
            {/*                    get access to educational technologies, reach their potential, and become better*/}
            {/*                    versions of themselves. The Zimble platform is just*/}
            {/*                    one-way Brima is achieving this vision.*/}


            {/*                </p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/mel.jpg')} alt="team img"/>*/}
            {/*                <h4>Melanie Roger</h4>*/}
            {/*                <p>Melanie Roger is a certified Project Management Professional and six sigma blackbelt*/}
            {/*                    with over 20 years of field experience. She is an expert in business operations,*/}
            {/*                    business optimization, business startups, mergers and acquisitions, integration*/}
            {/*                    management, advanced data analytics, and digital transformation. She is the Chief*/}
            {/*                    Operational Officer of Zeus Consulting Services a certified woman-owned and*/}
            {/*                    minority-owned business. </p>*/}
            {/*                <p>She has helped numerous business owners*/}
            {/*                    achieve their dream of business startups and has a proven track record of optimizing*/}
            {/*                    small businesses and large*/}
            {/*                    corporations achieve lower operating and maintenance costs while increasing revenue*/}
            {/*                    and sales. Melanie has a passion for*/}
            {/*                    the next generation and has volunteered countless hours ensuring underprivileged*/}
            {/*                    youth have access to quality education*/}
            {/*                    and creating programs so that they have hands-on access to STEM programs. </p><p>She*/}
            {/*                also believes in providing people with*/}
            {/*                second chances and volunteers with homeless outreach programs that aim to rehabilitate*/}
            {/*                and reintroduce those who have*/}
            {/*                been forgotten back into society.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/xia.jpg')} alt="team img"/>*/}
            {/*                <h4>Xiara Del Valle</h4>*/}
            {/*                <p>*/}
            {/*                    Xiara Del Valle is currently a student of Lynn University, completing studies in*/}
            {/*                    both Political Science and Fashion and Retail with a minor in Social*/}
            {/*                    Entrepreneurship. Her education has also lead her to completing a semester at*/}
            {/*                    Harvard University Extension school, where she was able to further her interests in*/}
            {/*                    women security and mass genocides.</p>*/}

            {/*                <p> Her work and passions without question reside in empowering others, with specific*/}
            {/*                    concentration in women and youth empowerment. Through this, Del Valle has been able*/}
            {/*                    to work with women cooperatives in Kayonza, Rwanda as well as start her own*/}
            {/*                    nonprofit, It’s H.E.R. Business (Helping Everyone Rebuild).</p>*/}
            {/*                <p> Her organization focuses on bringing the gaps between design and social issues.*/}
            {/*                    Through ethical fashion, women and youth around the world have been able to find a*/}
            {/*                    voice in injustices of poverty, a lack of education, sexual abuse and sexual*/}
            {/*                    assault.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/Alie.png')} alt="team img"/>*/}
            {/*                <h4>Aliesana Sandoval:</h4>*/}
            {/*                <p>*/}
            {/*                    Aliesana is a social entrepreneur who’s passion is to serve*/}
            {/*                    others by creating content that empowers, encourages, and*/}
            {/*                    educates others to heal, live, and thrive in their day-to-day lives.*/}
            {/*                </p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/gibson.jpg')} alt="team img"/>*/}
            {/*                <h4>Gibson Munene</h4>*/}
            {/*                <p>*/}
            {/*                    Gibson Munene is a software developer with a special interest in business,*/}
            {/*                    entrepreneurship,*/}
            {/*                    networking, blockchain, and machine*/}
            {/*                    learning. He has in the past been involved in the creation of peer to peer apps,*/}
            {/*                    blockchain solutions, DAAps, and*/}
            {/*                    machine learning algorithms.*/}
            {/*                </p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/Scott LeBlanc.jpg')} alt="team img"/>*/}
            {/*                <h4>Scott Leblanc</h4>*/}
            {/*                <p>Scott LeBlanc is a creative design professional with over 20 years of experience in art direction, design, and illustration. LeBlanc’s work has received national recognition with Gold and Silver Addy awards from the American Advertising Federation. He possesses a unique combination of advertising and marketing experience that can be effectively used to drive client objectives. He believes strongly in staying on the leading edge of technology.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/Noel.jpg')} alt="team img"/>*/}
            {/*                <h4>Kervin Noel</h4>*/}
            {/*                <p>Kervin Noel was born in Haiti in 1999 and eventually moved to Florida in 2005. Ever since he can remember, he has had a passion for art. That passion later developed into a proficiency for Graphic Design. Today he is in his third year of University, studying to receive his Bachelor of Fine Arts in Graphic Design. He has many plans for the future, including launching a clothing brand later this year.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/Jaelin.jpeg')} alt="team img"/>*/}
            {/*                <h4>Jaelin Forestier</h4>*/}
            {/*                <p>Jaelin Forestier is a senior at Lynn university studying graphic design*/}
            {/*                    and loves to illustrate as well as animate.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div class="card1">*/}
            {/*            <div class="box">*/}
            {/*                <img src={require('../images/Sal.jpg')} alt="team img"/>*/}
            {/*                <h4>Salma Moran</h4>*/}
            {/*                <p>Salma Moran is a B.F.A. Film Production student at Lynn University. She has a knack for leadership, organization, and creating art that emits a strong message in many forms. Directing and editing aren’t her only passions: she also has a minor on Social Impact because she believes that actions speak louder than words. Sal wants to create content in the future that portrays the imperfections in this world and brings to light conversations towards making the world a better place.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}

            <div className='gradient-half-primary-v1'>
                <AppFooter/>
            </div>
        </React.Fragment>

    )
}

export default Team;